"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleReactiveSearchProviderSearch = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("../../components");
const ExampleReactiveSearchProviderSearch = () => (react_1.default.createElement(components_1.ReactifySearchProvider, { mode: "search", shopifyPermanentDomain: "usereactify-demo.myshopify.com" },
    react_1.default.createElement(react_1.default.Fragment, null)));
exports.ExampleReactiveSearchProviderSearch = ExampleReactiveSearchProviderSearch;
//# sourceMappingURL=ExampleReactiveSearchProviderSearch.js.map